import * as React from 'react';
import { Box, CircularProgress } from '@mui/material';

export default function LoadingComponent() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        paddingTop: 2
      }}
    >
      <CircularProgress />
    </Box>
  );
}